export default __webpack_public_path__ + "static/Brandon-Bold-700-336d05b15c987e2518fa388e09fb2028.woff";